import DescriptionStep from '@/profile-creation-wizard/components/for-completion/ui/5_description/DescriptionStep.vue';
import RecommendationStep from '@/profile-creation-wizard/components/for-completion/ui/6_recommendation/RecommendationStep.vue';
import PrivacyStep from '@/profile-creation-wizard/components/for-completion/ui/7_privacy/PrivacyStep.vue';
import HeadlineStep from '@/profile-creation-wizard/components/for-creation/ui/1_headline/HeadlineStep.vue';
import CategorizationStep from '@/profile-creation-wizard/components/for-creation/ui/2_categorization/CategorizationStep.vue';
import ExpertiseStep from '@/profile-creation-wizard/components/for-creation/ui/3_expertise/ExpertiseStep.vue';
import LocalisationDetails from '@/profile-creation-wizard/components/for-creation/ui/4_localisation/LocalisationStep.vue';
import {
    OldCreationStepTrackingName,
    OldProfileCreationSteps,
    ProfileCreationStepGroup,
} from '@/profile-creation-wizard/config/steps/ProfileCreationSteps';
import {OldCreationStepRoute} from '@/profile-creation-wizard/config/steps/ProfileCreationRoutes';

export enum OldCreationStepNumber {
    SIGNUP_HEADLINE = 1,
    SIGNUP_CATEGORIZATION = 2,
    SIGNUP_EXPERTISE = 3,
    SIGNUP_LOCALISATION = 4,
    COMPLETION_DESCRIPTION = 5,
    COMPLETION_RECOMMENDATION = 6,
    COMPLETION_PRIVACY = 7,
}

export enum OldCreationStepPercentage {
    SIGNUP_HEADLINE = 5,
    SIGNUP_CATEGORIZATION = 50,
    SIGNUP_EXPERTISE = 50,
    SIGNUP_LOCALISATION = 50,
    COMPLETION_DESCRIPTION = 50,
    COMPLETION_RECOMMENDATION = 50,
    COMPLETION_PRIVACY = 95,
}

export enum OldCreationStepName {
    SIGNUP_HEADLINE = 'signup_headline',
    SIGNUP_CATEGORIZATION = 'signup_categorization',
    SIGNUP_EXPERTISE = 'signup_expertise',
    SIGNUP_LOCALISATION = 'signup_localisation',
    COMPLETION_DESCRIPTION = 'completion_description',
    COMPLETION_RECOMMENDATION = 'completion_recommendation',
    COMPLETION_PRIVACY = 'completion_privacy',
}

const totalStep = 7;

export const oldCreationSteps: OldProfileCreationSteps = [
    {
        name: OldCreationStepName.SIGNUP_HEADLINE,
        route: OldCreationStepRoute.SIGNUP_HEADLINE,
        stepNumber: OldCreationStepNumber.SIGNUP_HEADLINE,
        stepCount: totalStep,
        stepPercentage: OldCreationStepPercentage.SIGNUP_HEADLINE,
        previousStepName: null,
        nextStepName: OldCreationStepName.SIGNUP_CATEGORIZATION,
        group: ProfileCreationStepGroup.SIGNUP,
        component: HeadlineStep,
        trackingName: OldCreationStepTrackingName.SIGNUP_HEADLINE,
    },
    {
        name: OldCreationStepName.SIGNUP_CATEGORIZATION,
        route: OldCreationStepRoute.SIGNUP_CATEGORIZATION,
        stepNumber: OldCreationStepNumber.SIGNUP_CATEGORIZATION,
        stepCount: totalStep,
        stepPercentage: OldCreationStepPercentage.SIGNUP_CATEGORIZATION,
        previousStepName: OldCreationStepName.SIGNUP_HEADLINE,
        nextStepName: OldCreationStepName.SIGNUP_EXPERTISE,
        group: ProfileCreationStepGroup.SIGNUP,
        component: CategorizationStep,
        trackingName: OldCreationStepTrackingName.SIGNUP_CATEGORIZATION,
    },
    {
        name: OldCreationStepName.SIGNUP_EXPERTISE,
        route: OldCreationStepRoute.SIGNUP_EXPERTISE,
        stepNumber: OldCreationStepNumber.SIGNUP_EXPERTISE,
        stepCount: totalStep,
        stepPercentage: OldCreationStepPercentage.SIGNUP_EXPERTISE,
        previousStepName: OldCreationStepName.SIGNUP_CATEGORIZATION,
        nextStepName: OldCreationStepName.SIGNUP_LOCALISATION,
        group: ProfileCreationStepGroup.SIGNUP,
        component: ExpertiseStep,
        trackingName: OldCreationStepTrackingName.SIGNUP_EXPERTISE,
    },
    {
        name: OldCreationStepName.SIGNUP_LOCALISATION,
        route: OldCreationStepRoute.SIGNUP_LOCALISATION,
        stepNumber: OldCreationStepNumber.SIGNUP_LOCALISATION,
        stepCount: totalStep,
        stepPercentage: OldCreationStepPercentage.SIGNUP_LOCALISATION,
        previousStepName: OldCreationStepName.SIGNUP_EXPERTISE,
        nextStepName: OldCreationStepName.COMPLETION_DESCRIPTION, // signup
        group: ProfileCreationStepGroup.SIGNUP,
        component: LocalisationDetails,
        trackingName: OldCreationStepTrackingName.SIGNUP_LOCALISATION,
    },
    {
        name: OldCreationStepName.COMPLETION_DESCRIPTION,
        route: OldCreationStepRoute.COMPLETION_DESCRIPTION,
        stepNumber: OldCreationStepNumber.COMPLETION_DESCRIPTION,
        stepCount: totalStep,
        stepPercentage: OldCreationStepPercentage.COMPLETION_DESCRIPTION,
        previousStepName: null, // signup
        nextStepName: OldCreationStepName.COMPLETION_RECOMMENDATION,
        group: ProfileCreationStepGroup.COMPLETION,
        component: DescriptionStep,
        trackingName: OldCreationStepTrackingName.COMPLETION_DESCRIPTION,
    },
    {
        name: OldCreationStepName.COMPLETION_RECOMMENDATION,
        route: OldCreationStepRoute.COMPLETION_RECOMMENDATION,
        stepNumber: OldCreationStepNumber.COMPLETION_RECOMMENDATION,
        stepCount: totalStep,
        stepPercentage: OldCreationStepPercentage.COMPLETION_RECOMMENDATION,
        previousStepName: OldCreationStepName.COMPLETION_DESCRIPTION,
        nextStepName: OldCreationStepName.COMPLETION_PRIVACY,
        group: ProfileCreationStepGroup.COMPLETION,
        component: RecommendationStep,
        trackingName: OldCreationStepTrackingName.COMPLETION_RECOMMENDATION,
    },
    {
        name: OldCreationStepName.COMPLETION_PRIVACY,
        route: OldCreationStepRoute.COMPLETION_PRIVACY,
        stepNumber: OldCreationStepNumber.COMPLETION_PRIVACY,
        stepCount: totalStep,
        stepPercentage: OldCreationStepPercentage.COMPLETION_PRIVACY,
        previousStepName: OldCreationStepName.COMPLETION_RECOMMENDATION,
        nextStepName: null, // profile page
        group: ProfileCreationStepGroup.COMPLETION,
        component: PrivacyStep,
        trackingName: OldCreationStepTrackingName.COMPLETION_PRIVACY,
    },
];
